export default {

    loginUser: '/loginUser',  //用户登录
    logout: '/logout',     //退出登录

    profile: '/account/profile',          //个人信息
    updatePwd: '/account/updatePwd',          //修改密码

    getMenus: '/getMenus',       //菜单

    getSummary: '/getSummary',       //首页-汇总信息

    getLogs: '/system/log/getLogs',     //系统日志

    getUsers: '/system/user/getUsers',      //用户列表
    getUserById: '/system/user/getUserById/{id}',      //获取用户
    saveUser: '/system/user/save',   //编辑用户
    removeUser: '/system/user/remove/{id}',      //删除用户
    checkUserName: '/system/user/checkUserName/{id}',   //检查用户名

    getModules: '/system/module/getModules',     //模块列表
    saveModule: '/system/module/save',   //编辑模块
    removeModule: '/system/module/remove/{id}',      //删除模块

    getRoles: '/system/role/getRoles',     //角色列表
    saveRole: '/system/role/save',   //编辑角色
    removeRole: '/system/role/remove/{id}',      //删除角色

    getGroups: '/system/group/getGroups',     //组织结构
    getUsersByGroup: '/system/group/getUsersByGroup',     //组织下用户列表
    saveGroup: '/system/group/save',   //编辑组织结构
    removeGroup: '/system/group/remove/{id}',      //删除组织结构

    getRights: '/system/right/getRights',     //权限设置
    saveRight: '/system/right/save',   //编辑权限

    getDatas: '/system/data/getDatas',     //基础数据
    saveData: '/system/data/save',   //编辑基础数据
    removeData: '/system/data/remove/{id}',      //删除基础数据

    getClients: '/system/client/getClients',     //基础数据/客户管理
    saveClient: '/system/client/save',   //基础数据/编辑客户
    removeClient: '/system/client/remove/{id}',      //删除客户

    getSuppliers: '/system/supplier/getSuppliers',     //供应商
    saveSupplier: '/system/supplier/save',   //编辑供应商
    removeSupplier: '/system/supplier/remove/{id}',      //删除供应商

    getProducts: '/system/product/getProducts',     //产品价格
    saveProduct: '/system/product/save',   //编辑产品价格
    removeProduct: '/system/product/remove/{id}',      //删除产品价格

    getProjects: '/project/getProjects',    //项目

    getSalesOrders: '/sales/order/getSalesOrders',      //销售订单列表
    saveSalesOrder: '/sales/order/save',      //编辑销售订单
    removeSalesOrder: '/sales/order/remove/{id}',      //删除销售订单

    getLenders: '/finance/lender/getLenders',      //应付列表
    saveLender: '/finance/lender/save',      //编辑付款信息

    getDeposits: '/finance/deposit/getDeposits',      //押金列表
    getDepositSum: '/finance/deposit/getDepositSum',      //押金汇总

    getProfits: '/finance/profit/getProfits',      //利润列表

    getImages: '/image/getImages',     //图库
    saveImage: '/image/save',   //编辑图库
    removeImage: '/image/remove/{id}',      //删除图库

    uploadFile: '/common/uploadFile',        //文件上传
    importExcel: '/common/importExcel',        //导入数据
    salesContract: '/common/generateWord/salesContract/SalesContract.docx/',        //生成Word文件
    salesContractEn: '/common/generateWord/salesContract/SalesContractEn.docx/',        //生成Word文件

    getCompanies: '/system/company/getCompanies',     //数据管理/和谐企业/
    getCompanyCreateYears: '/system/company/getCreateYears',     //数据管理/和谐企业/
    getCheckYears: '/system/company/getCheckYears',     //数据管理/和谐企业/
    getStarYears: '/system/company/getStarYears',     //数据管理/和谐企业/
    getCompanyStreets: '/system/company/getStreets',     //数据管理/和谐企业/
    saveCompany: '/system/company/save',   //数据管理/编辑和谐企业
    removeCompany: '/system/company/remove/{id}',      //数据管理/删除和谐企业
    importCompany: '/upload/company',        //导入和谐企业数据
    exportCompany: '/download/company',        //导出和谐企业数据
    clear: '/system/company/clear',   //清空和谐企业

    getEnterprises: '/system/enterprise/getEnterprises',     //数据管理/和谐企业/
    getKeyYears: '/system/enterprise/getKeyYears',     //数据管理/和谐企业/
    getEnterpriseStreets: '/system/enterprise/getStreets',     //数据管理/和谐企业/
    saveEnterprise: '/system/enterprise/save',   //数据管理/编辑和谐企业
    removeEnterprise: '/system/enterprise/remove/{id}',      //数据管理/删除和谐企业
    importEnterprise: '/upload/enterprise',        //导入和谐企业数据
    exportEnterprise: '/download/enterprise',        //导出和谐企业数据

    getCorporations: '/system/corporation/getCorporations',     //数据管理/历年取消和谐企业称号/
    getCreateYears: '/system/corporation/getCreateYears',     //数据管理/历年取消和谐企业称号/
    getStreets: '/system/corporation/getStreets',     //数据管理/历年取消和谐企业称号/
    getCancelYears: '/system/corporation/getCancelYears',     //数据管理/历年取消和谐企业称号/
    saveCorporation: '/system/corporation/save',   //数据管理/编辑历年取消和谐企业称号
    removeCorporation: '/system/corporation/remove/{id}',      //数据管理/删除历年取消和谐企业称号
    importCorporation: '/upload/corporation',        //导入历年取消和谐企业称号数据
    exportCorporation: '/download/corporation',        //导出历年取消和谐企业称号数据

    getChecks: '/system/company/getChecks',     //和谐企业用工体检
    getStars: '/system/company/getStars',     //和谐企业示范展示

    getNewses: '/system/news/getNewses',     //和谐简讯
    saveNews: '/system/news/save',   //编辑和谐简讯
    removeNews: '/system/news/remove/{id}',      //删除和谐简讯
    importNews: '/upload/news',        //导入和谐简讯
    exportNews: '/download/news',        //导出和谐简讯

    sendCode: '/system/sms/sendCode',   //发送验证码
    checkCode: '/system/sms/checkCode', //验证验证码

    getSupports: '/system/support/getSupports',     //数据管理/扶持企业/
    getCompanyTypes: '/system/support/getCompanyTypes',     //数据管理/扶持企业/企业类型
    getStaffSizes: '/system/support/getStaffSizes',     //数据管理/扶持企业/人员规模
    saveSupport: '/system/support/save',   //数据管理/编辑扶持企业
    removeSupport: '/system/support/remove/{id}',      //数据管理/删除扶持企业
    importSupport: '/upload/support',        //导入扶持企业数据
    exportSupport: '/download/support',        //导出扶持企业数据
}